<div class="checkbox-container">
  @let control = getControl();
  <label class="checkbox-label" [ngClass]="{ 'error-state': !control.untouched && control.invalid }">
    <input type="checkbox"
           class="checkbox-input"
           [formControl]="control"
           [attr.aria-required]="required()">
    <span class="checkbox-custom"></span>
    <span class="label-text">
      {{ label() }}
      @if (required()) {
        <span class="required-indicator" aria-label="required">*</span>
      }
    </span>
  </label>
</div>
